function getProductContent(product) {
  const PRODUCT_CONTENT_TYPE = "short_description";
  let content;
  let description = "";
  let tags = [];
  let customLink = "";
  if (Array.isArray(product?.content)) {
    content = product.content?.find(
      (block) => block.type === PRODUCT_CONTENT_TYPE
    )?.data ?? product.content[0]?.data;
  } else {
    content = product?.content;
  }
  if (content) {
    if (typeof content === "string") {
      description = content;
    } else {
      description = content.description ?? "";
      tags = content.tags ?? [];
      customLink = content.customLink ?? "";
    }
  }
  return {
    description,
    tags,
    customLink
  };
}
function getProductDescription(product) {
  const content = getProductContent(product);
  return content.description;
}
function getProductTags(product) {
  const { tags } = getProductContent(product);
  return tags;
}
function getProductImage(product) {
  const image = product?.variations?.[0].images?.[0];
  return !image ? null : { src: image };
}
function getProductCustomLink(product) {
  const { customLink } = getProductContent(product);
  return customLink;
}
function getProductLink(product) {
  return getProductCustomLink(product) || `/product/${product.slug}`;
}
export {
  getProductDescription,
  getProductImage,
  getProductLink,
  getProductTags
};
